import {clickEvent} from "../../../../webpack/modules/events";

clickEvent('#product-list-page .open-product-list-reviews', true, function() {
    let offcanvas = Offcanvas.getOrCreateInstance(document.querySelector('#reviews-offcanvas'));
    offcanvas.show();
});